import request from '@/utils/request'

export function getAllHotelApi(query) {
  return request({
    url: '/config-service/v1/hotel/hotel/all',
    method: 'get',
    params: query
  })
}
